var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { deepMerge } from "sb-helpers";
import { apiRequestGateway } from "sb-authorization-lib";
import { GlobalConfig } from "../../configuration";
/**
 * @export
 * @class BaseApiClient
 */
export class BaseApiClient {
    constructor(configuration, ajaxService) {
        this.ajaxService = ajaxService;
        this.configuration = configuration;
    }
    /**
     * Prepare URL and options for AJAX request
     * @param request
     */
    getFetchOptions(request, token) {
        var headers = {
            "Content-Type": "application/json-patch+json",
            Authorization: `Bearer ${token || this.configuration.accessToken}`,
            locale: this.configuration.locale
        };
        if (this.configuration.blockId) {
            headers["block-id"] = this.configuration.blockId;
        }
        return {
            method: "POST",
            headers,
            body: JSON.stringify(request || {})
        };
    }
    /**
     * Execute AJAX request to BFF
     * @param url BFF endpoint
     * @param request Request object to be send
     */
    executeRequest(url, fetchOptions) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.configuration.accessToken) {
                return this.executingAjax(url, fetchOptions);
            }
            else {
                return apiRequestGateway().getToken().then(x => {
                    GlobalConfig.setAuthorization({ token: x });
                    fetchOptions.token = x;
                    return this.executingAjax(url, fetchOptions);
                });
            }
        });
    }
    executingAjax(url, fetchOptions) {
        return __awaiter(this, void 0, void 0, function* () {
            let fetchUrl = this.configuration.basePath + url;
            let options = this.getFetchOptions(fetchOptions.request, fetchOptions.token);
            if (fetchOptions) {
                options = deepMerge(options, fetchOptions.fetchOptOverride);
            }
            if (options.method === "GET" || options.method === "HEAD") {
                delete options.body;
            }
            let response = yield this.ajaxService.send(fetchUrl, options);
            if (response.status >= 200 && response.status < 300) {
                return yield response.json();
            }
            else {
                throw response;
            }
        });
    }
    refreshToken(token) {
        this.configuration.accessToken = token;
        return this;
    }
}
;
//# sourceMappingURL=BaseApiClient.js.map